"use client"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

interface ImportSubscribersConfirmationModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  segmentName?: string
  onConfirm: () => void
}

export function ImportSubscribersConfirmationModal({
  open,
  onOpenChange,
  segmentName,
  onConfirm,
}: ImportSubscribersConfirmationModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[462px]">
        <div className="flex flex-col gap-4">
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold leading-none tracking-tight">
              Ready to import subscribers
            </DialogTitle>
          </DialogHeader>

          <p className="text-sm leading-5 text-muted-foreground">
            {segmentName
              ? `New subscribers will be added to your segment "${segmentName}".`
              : "New subscribers will be added to your publication."}{" "}
            Duplicates will be skipped and existing subscribers won't be
            affected.
          </p>

          <div className="flex items-center justify-end gap-3">
            <Button variant="secondary" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button onClick={onConfirm}>Import subscribers</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
